import loi from "./loi/en";

export default {
  loi,
};
